import { ResponseType } from 'axios';
import { HTTP_METHOD, ENDPOINT } from 'src/constants/api';
import { DTO } from './base.dto';

export class LogoutDTO extends DTO {
	public param: object | undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.LOGOUT;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseClass = String;
	public readonly responseType: ResponseType = 'json';
}
